export default __webpack_public_path__ + "static/media/cryptonews.6e4a62e6.png";